import { config } from 'env_def';
import { ErrMsgCodeMap } from '@/api/errMap';
function checkAccountAndDomain(accountDomainInfo) {
    if (!accountDomainInfo || !accountDomainInfo.account || !accountDomainInfo.domain) {
        return false;
    }
    return true;
}
function getInputEmailErrorMsg() {
    return getErrorMsgByErrorCode('ERR.LOGIN.ILLEGALINPUT');
}
function getErrorMsgByErrorCode(errCode) {
    return ErrMsgCodeMap[errCode];
}
function getMailModeValByMailModeCode(mailCode) {
    const codeToConfigKey = {
        hm: 'mail_mode_HMail',
        cm: 'mail_mode_corpMail',
    };
    const configKey = codeToConfigKey[mailCode];
    return config(configKey);
}
function getDefaulaMailModeVal() {
    return config('default_mail_mode');
}
function getCorpMailModeVal() {
    return config('mail_mode_corpMail');
}
function getHMailModeVal() {
    return config('mail_mode_HMail');
}
export function getMaiModeFromPreLoginResponse(res) {
    if (String(res.code) !== '200') {
        return getDefaulaMailModeVal();
    }
    const resData = res.data || {};
    const mailSys = (resData === null || resData === void 0 ? void 0 : resData.sys) || 'hm';
    return getMailModeValByMailModeCode(mailSys);
}
export function getIsCorpMailMode(mailModeVal) {
    return mailModeVal === getCorpMailModeVal();
}
export default {
    getMaiModeFromPreLoginResponse,
    getIsCorpMailMode,
    getCorpMailModeVal,
    getHMailModeVal,
    getDefaulaMailModeVal,
    checkAccountAndDomain,
    getInputEmailErrorMsg,
};
